import { Component, Input, ViewChild } from '@angular/core';
import { MerchantService } from '../../../models/merchant/merchantService';
import { Options } from '../../../components/ui/filterable-table/options';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { OrdersTableViewComponent } from '../../../components/orders/orders-table-view/orders-table-view.component';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { StorageService } from '../../../core/storage/storageService';
import { AccessManager } from '../../../components/ui/access-manager/access-manager';

@Component({
  selector: 'app-merchant-orders-page',
  standalone: false,
  templateUrl: './merchant-orders-page.component.html',
})
export class MerchantOrdersPageComponent {
  public PAGE_ACCESS_NAMESPACE: string = AccessManager.AUTH_SELECT_MERCHANT_ORDERS;
  @Input() merchantId: string | undefined;

  @ViewChild('ordersTable') ordersTableControl:
    | OrdersTableViewComponent
    | undefined;

  tableView: any;
  selectedOrder: Partial<OrderDetails> | undefined;
  ordersTableOptions: Options = new Options({
    debug: 'merchant-orders',
    selectAction: 'popup',
    filterable: true,
  });

  constructor(private merchantService: MerchantService, private storage: StorageService, private accessManager: AccessManager) {
    this.tableView = new TableView(OrdersTableViewComponent);
  }

  ngAfterViewInit() {
    if (this.merchantId) {
      this.ordersTableOptions.merchantId = this.merchantId;
      this.ordersTableControl?.setOptions(this.ordersTableOptions);
    } else {
      this.merchantId = this.storage.getSelectedLocation()?.id;
      this.ordersTableOptions.merchantId = this.merchantId!;
      this.ordersTableControl?.setOptions(this.ordersTableOptions);
    }
  }
}
